import styled from 'styled-components'
import { vimovaTheme } from '../../theme/vimovaTheme'

export const PageContainer = styled.div`
  width: 210mm;
  max-width: 210mm;
  height: 297mm;
  margin: 0;
  padding: 0;
  position: relative;
  overflow: hidden;
  font-family: ${vimovaTheme.fonts.body};
  box-sizing: border-box;
  background-color: ${vimovaTheme.colors.white};
  display: flex;
  flex-direction: column;

  @media print {
    width: 100% !important;
    max-width: 100% !important;
    display: flex !important;
    flex-direction: column !important;
    position: relative !important;
    height: 297mm !important;
    min-height: 297mm !important;
    max-height: 297mm !important;
    overflow: hidden !important;
    page-break-after: always !important;
    page-break-inside: avoid !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
    background-color: ${vimovaTheme.colors.white} !important;
  }
`

export const ContentArea = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 16mm 20mm 0 20mm;

  @media print {
    flex: 1 !important;
    display: flex !important;
    flex-direction: column !important;
    padding: 16mm 20mm 0 20mm !important;
  }
`

export const FooterWrapper = styled.div`
  position: relative;
  margin-top: auto;
  margin-bottom: 0;
  padding-bottom: 0;
  border: none;

  @media print {
    position: relative !important;
    margin-top: auto !important;
    margin-bottom: 0 !important;
    padding-bottom: 0 !important;
    border: none !important;
  }
`
